import { Component, ViewEncapsulation } from '@angular/core';
import {Router, NavigationEnd} from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None,

})
export class AppComponent {
  public location: string;

  constructor(public router: Router) {

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {

        // Get the first part of url.
        const parts = router.url.split('/');
        this.location = parts[1];
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts